import { createFileRoute } from "@tanstack/react-router";

import { AppSettingsPage } from "@/features/content/pages";

/** What the apps read when they open: support contacts and version gates. */
export const Route = createFileRoute("/_app/settings/apps")({
  component: AppSettingsPage,
});
